export default {
    updateGroupId(state, payload) {
        if (!payload) return;
        state.Group = payload;
        state.GroupId = payload.groupId;
    },
    updateTotalPage(state, payload) {
        state.TotalInfo = payload;
    },

    updateGroups(state, payload) {
        state.Groups = payload;
    },
}